import { trackLead } from './leads';

export const fireMalLeadTracking = function(malLeads, opts={}) {
  const leadGuids = {},
        malListings = opts.malListings,
        guidsForAdobeDtm = [];
  if(malLeads){
    if (malLeads instanceof Array) {
      //create a hashmap of all checked mal properties
      malLeads.forEach(function(lead) {
        leadGuids[lead.listing_id] = lead.id;
        guidsForAdobeDtm.push(lead.id);
      });
    }
    else{
      guidsForAdobeDtm.push(malLeads.id);
    }
    //compare the above map with all potential malListings and submit the ones that were selected.
    if (malListings) {trackMalLeads(malListings, leadGuids, opts )}
  }
  updateDtmObject(guidsForAdobeDtm);
};

const trackMalLeads = (malListings, leadGuids, opts) => {
  const placementData = MOVE_DATA.leadAdobeDTM.placementData;

  malListings.forEach(function(property, index){
    const mal_checked = `#might_also_like_listing_${index+1}`;
    var mal_data = $(mal_checked) && $(mal_checked)[0].checked;
    if ( property.status === "ready_to_build" && mal_data === true ){
      MOVE_DATA.leadAdobeDTM.leadGuid = leadGuids[$(mal_checked).data('listingid')];
    }
    if (property.listing_id && leadGuids[property.listing_id.toString()]) {
      const status = property.status === "for_sale" ? property.status : "new_community_plan";
      // rdc-tracking library supports only 'new_plan' not 'new_community_plan' as its
      // property status, so need to have type as 'new_plan'
      // https://github.move.com/ConsumerTech/rdc-tracking/blob/master/source/index.js#L37
      const type = property.status === "for_sale" ? status : 'new_plan';
      const linkName = `web:leads:${status}:${property.lead_attributes.lead_type}:mal:pas_${index}`;

      const trackingOptions = {
                                leadGuid: leadGuids[property.listing_id.toString()],
                                is_mal: true,
                                placementData: placementData,
                                leadValue: opts.leadValue,
                                linkName: linkName,
                                initialLeadValue: opts.initialLeadValue,
                                property_type: type,
                                property_status: status,
                                type: property.property_type
                              };
      trackLead(Object.assign({}, property, trackingOptions ));
    }
  })
}

const updateDtmObject = (guidsForAdobeDtm) => {
  MOVE.Helper.updateOmnitureLeadJson({ leadGuid: guidsForAdobeDtm, malCt: guidsForAdobeDtm.length });
}



// WEBPACK FOOTER //
// ./shared_critical/tracking/shared/mal_leads.js